import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import AOS from "aos";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import Antd from 'ant-design-vue';
import permissionDirective from "./directives/permission";
import { hasPermission } from "./utils/permission";
import { isAuthenticated } from "./utils/auth";
import { useCurrentUser } from "./composables/useCurrentUser";

import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "swiper/css";
import "swiper/css/bundle";

import i18n from "./i18n";
import "./assets/custom.scss";
import "ant-design-vue/dist/reset.css";

import { setupInterceptors } from "./services/api";

const bootstrap = async () => {
  setupInterceptors(router);

  if (isAuthenticated()) {
    const { fetchCurrentUser } = useCurrentUser();
    await fetchCurrentUser(true);
  }

  const app = createApp(App).use(router);
  app.use(i18n);
  app.mixin({
    mounted() {
      AOS.init();
    },
  });
  app.use(BootstrapVueNext);
  app.use(VueApexCharts);
  app.use(Antd);

  app.directive("permission", permissionDirective);
  app.config.globalProperties.$can = hasPermission;

  app.mount('#app');
};

bootstrap();
